    <div class="componente-importantes text-start px-5 mt-3" style="min-height:700px ;" >
        <section class="row">
            <div class="col">
            <div>
                <h5 class="ms-3">Informacion de la configuracion de los pagos</h5>
            </div>
                    <section class="backgroundTable row mx-2 mt-5 pb-5">
            <div class="col-12 ">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="componente-importantes">
                    <thead>
                        <tr >
                            <th class="text-white text-center" >Fecha Inicio</th>
                            <th class="text-white text-center" >Fecha Término</th>
                            <th class="text-white text-center" >Estructura Seleccionada</th>
                            <th class="text-white text-center" >Tipo de moneda</th>
                            <th class="text-white text-center" >Monto Seleccionado</th>
                    </thead>
                    <tbody>
            <tr >

              <td class="text-center" >{{pagos.startDate}}</td>
              <td class="text-center">{{pagos.endDate}} </td>
              
              <td class="text-center">
                {{pagos.playTempleteDescription}}
              </td>
              <td class="text-center">{{pagos.playOptionDescription}}</td>
              <td class="text-center">{{pagos.monto}}</td>
            </tbody>
                </table>
            </div>
            
        </section>
            </div>

        <div class="mt-5">
                <h5 class="">Detalles de pagos</h5>
        </div>
        <form [formGroup]="paymentsform" class="needs-validation">
          <div formArrayName="items"  *ngFor="let item of paymentsform.get('items')['controls']; let i = index;">
            <div class="row" [formGroupName]="i">
              <div class="col-4 form-group">
                <div class="d-flex justify-content-start mt-3 mb-2">
                  <label  class="text-white">Detalles</label>
                </div>
                <input type="text" required  class="custom-outline-input date form-control"  formControlName="title" />
                <div class="invalid-feedback">
                  Llene el campo Detalles.
                 </div>
              </div>
              <div class="col-4 form-group">
                <div class="d-flex justify-content-start mt-3 mb-2">
                  <label for="startDate" class="text-white">Monto</label>
                </div>
                <input type="text" class="custom-outline-input date form-control" disabled [value]="item.value.pay_amount" required/>
                
              </div>
              <div class="col-4 form-group">
                <div class="d-flex justify-content-start mt-3 mb-2">
                  <label class="text-white">Fecha de Pago</label>
                </div>
                <input type="date" formControlName="scheduled_date" id="scheduled_date" required class="custom-outline-input date form-control" />
                <div class="invalid-feedback">
                  Llene el campo Fecha de Pago.
                 </div>
              </div>
            </div>
          </div>
        </form>
        <div class="row mt-3">
            <div class="col-12 d-flex justify-content-end align-items-end">
                <button (click)="formSubmit()"  class="mx-2 btn btn-outline-light"> <i class="fa fa-floppy-disk" aria-hidden="true"></i>  Guardar datos</button>
            </div>
        </div>

        </section>
        
        
    </div>
